import { Components } from "@mui/material";

export const MuiLink: Components["MuiLink"] = {
  defaultProps: {
    underline: "none",
  },
};
